import document from 'document';

export const selector = (selectors, key, all) => {
    if(all) {
        return document.querySelectorAll(`${selectors.root} ${selectors[key]}`);
    }
    return document.querySelector(`${selectors.root} ${selectors[key]}`);
};

export const getChild = (parent, filter) => {
    for(var key = 0; key < parent.children.length; key++) {
        if (matches(parent.children[key], filter)) {
            return  parent.children[key];
        }
        const child = getChild(parent.children[key], filter);
        if(child) return child;
    }
}

function matches(elem, filter) {
    if (elem && elem.nodeType === 1) {
        if (filter) {
        return elem.matches(filter);
        }
        return true;
    }
    return false;
}

// this will start from the current element and get all of
// the next siblings
export const  getNextSiblings = (elem, filter) => {
    var sibs = [];
    while ((elem = elem.nextSibling)) {
        if (matches(elem, filter)) {
            sibs.push(elem);
        }
    }
    return sibs;
}

// this will start from the current element and get all the
// previous siblings
export const getPreviousSiblings = (elem, filter) => {
    var sibs = [];
    while ((elem = elem.previousSibling)) {
        if (matches(elem, filter)) {
        sibs.push(elem);
        }
    }
    return sibs;
}

// this will start from the first child of the current element's
// parent and get all the siblings

export const getAllSiblings = (elem, filter) => {
    var sibs = [];
    elem = elem.parentNode.firstChild;
    while ((elem = elem.nextSibling)) {
        if (matches(elem, filter)) {
        sibs.push(elem);
        }
    }
    return sibs;
}

export const getElementByFilter = (filter) => {
    return document.querySelector(filter);
}
